<template>
  <div class="address-list-container">
    <v-radio-group
      class="radio-group"
      hide-details
      :value="value"
      @change="handleChange"
      v-if="!isLoading"
    >
      <v-layout
        pa-3
        class="order-item"
        v-for="(item, index) in addressList"
        :key="index"
      >
        <v-layout row>
          <v-layout shrink v-if="isSelection">
            <v-radio :value="item.addressId" />
          </v-layout>
          <v-layout column>
            <v-layout mb-2 align-center class="address-info">
              <v-flex class="default" shrink v-if="item.defaultFlag == 1">
                {{ $t("addressList.default") }}
              </v-flex>
              <v-flex class="number" shrink>{{ item.man }}</v-flex>
              <v-flex class="time" shrink>{{ item.phone }}</v-flex>
            </v-layout>
            <v-layout justify-center>
              <v-flex class="time">
                {{ item.area }} {{ item.cityName }} {{ item.address }}
              </v-flex>
            </v-layout>
          </v-layout>
          <v-layout column align-end justify-center grow shrink>
            <router-link
              class="menu-item"
              :to="{
                name: 'address-edit',
                params: { addressId: item.addressId },
                query: {
                  editSuccessRedirectType: editSuccessRedirectType,
                  item
                }
              }"
            >
              {{ $t("addressList.edit") }}
            </router-link>
          </v-layout>
        </v-layout>
      </v-layout>
      <v-flex mt-4>
        <v-btn
          color="primary"
          round
          @click="$router.push({ name: 'address-create' })"
        >
          {{ $t("addressList.createAddress") }}
        </v-btn>
      </v-flex>
    </v-radio-group>

    <Loading v-if="isLoading" />
  </div>
</template>

<script>
import { mapMutations } from "vuex";
import Loading from "../../components/common/loading";

import account from "../../api/account";
export default {
  props: {
    isSelection: {
      type: Boolean,
      default: false
    },
    value: {
      type: String,
      default: null
    },
    createSuccessRedirectType: {
      type: String,
      default: null
    },
    editSuccessRedirectType: {
      type: String,
      default: null
    }
  },
  data() {
    return {
      addressList: [],
      isLoading: true
    };
  },
  mounted() {
    this.loadGoodsList();
  },
  components: {
    Loading
  },
  methods: {
    ...mapMutations(["setAddressId"]),
    handleChange(e) {
      this.setAddressId(e);
    },
    async loadGoodsList() {
      this.isLoading = true;
      try {
        const res = await account.addressList();
        this.isLoading = false;
        if (res.data.status == "fail") {
          this.$toasted.show(res.data.msg);
        } else if (res.data.status == "SUCCESSS") {
          this.addressList = res.data.data;
        }
      } catch (e) {
        console.log(e);
      }
    }
  }
};
</script>

<style scoped lang="sass" src="./address-list.sass"></style>
